import { render, staticRenderFns } from "./MemberChangePwd.vue?vue&type=template&id=83041c0c&scoped=true&"
import script from "./MemberChangePwd.vue?vue&type=script&lang=js&"
export * from "./MemberChangePwd.vue?vue&type=script&lang=js&"
import style0 from "./MemberChangePwd.vue?vue&type=style&index=0&id=83041c0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83041c0c",
  null
  
)

export default component.exports